module.exports = __webpack_public_path__ + "static/NeueHaasUnicaW1G-LightItalic-ddb9744cf4303002cf8d39531cc42a71.ttf";